import { ComponentProps, FC } from 'react';

import { StyledDiv } from './styles';

interface IDeparturePointIconProps extends ComponentProps<'svg'> {
	disabled?: boolean;
}

export const DeparturePointIcon: FC<IDeparturePointIconProps> = ({
	disabled = false,
	...props
}) => (
	<StyledDiv disabled={disabled}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="15"
			height="15"
			fill="none"
			{...props}
		>
			<path
				fill="currentColor"
				d="m7.56 12 2.78-2.77a3.93 3.93 0 1 0-5.56 0l2.78 2.78Zm0 1.6L4 10.03a5.05 5.05 0 1 1 7.14 0L7.56 13.6Zm0-6.02a1.12 1.12 0 1 0 0-2.25 1.12 1.12 0 0 0 0 2.25Zm0 1.12a2.24 2.24 0 1 1 0-4.49 2.24 2.24 0 0 1 0 4.49Z"
			/>
		</svg>
	</StyledDiv>
);
